import api_call_v2 from "utils/API_CALL/api_call_v2";
import PROXY_CONFIG from "../../Config/ProxyConfig";
import { encrypt, decrypt } from "utils/CRYPTO/secret"
const GetDataAnnonces = async (properties) => {
  let region = properties.region;
  let province = properties.province;
  let commune = properties.commune;
  let quartier = properties.quartier;
  let force = properties.force
  if (!properties.prix_appartement && !properties.prix_villa && !force) {
    quartier = null;
    commune = null;
  }
  return new Promise((resolve, reject) => {
    if (!quartier && !commune) {
      resolve([]);
    } else {

      api_call_v2(
        undefined,
        "post",
        "annonces/list",
        {
          data: encrypt({

            region: region,
            province: province,
            quartier: quartier ? [quartier] : null,
            commune: commune,
            pageSize: 5,
            page: 0,
            type: null,
          })
        }
      )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {

          reject(err);
        });
    }
  });
};


export default GetDataAnnonces;
